module.exports = __webpack_public_path__ + "static/media/pop_miniX.d72a8832.svg";